import { CLIENTS } from "../../lib/data";

const ClientItem = ({ name, position }) => (
  <div
    data-testid={`client-item-${name}`}
    className="text-sm md:text-base font-medium tracking-tight border-b hairline pb-3 flex items-baseline justify-between"
  >
    <span>{name}</span>
    <span className="font-mono text-[10px] opacity-40">
      /{String(position + 1).padStart(2, "0")}
    </span>
  </div>
);

const ClientCategory = ({ category, names, index }) => (
  <div
    data-testid={`client-category-${index}`}
    className="grid grid-cols-12 gap-6 hairline-t border-t pt-8 md:pt-10 reveal"
  >
    <div className="col-span-12 md:col-span-3">
      <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
        Category {String(index + 1).padStart(2, "0")}
      </div>
      <h3 className="text-2xl md:text-3xl font-bold tracking-tight">
        {category}
      </h3>
    </div>
    <div className="col-span-12 md:col-span-9 grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4">
      {names.map((n, i) => (
        <ClientItem key={n} name={n} position={i} />
      ))}
    </div>
  </div>
);

const ClientsMarquee = ({ items }) => (
  <div data-testid="clients-marquee" className="hairline-b border-b overflow-hidden py-5">
    <div className="marquee-track text-sm tracking-[0.3em] uppercase font-medium opacity-70">
      {[...items, ...items].map((c, i) => (
        <span key={`${c}-${i}`} className="inline-flex items-center gap-16">
          {c} <span className="text-[var(--accent)]">·</span>
        </span>
      ))}
    </div>
  </div>
);

const ClientsIntro = () => (
  <div className="grid grid-cols-12 gap-6 mb-12 md:mb-16">
    <div className="col-span-12 md:col-span-4">
      <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
        05 — Selected Clients
      </div>
      <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-[0.95]">
        The brands<br />on the brief.
      </h2>
    </div>
    <div className="col-span-12 md:col-span-6 md:col-start-7 self-end">
      <p className="text-base md:text-lg leading-relaxed text-[var(--muted)] max-w-prose">
        A roster across healthcare, retail, FMCG and technology — category
        leaders trusted with multi-crore mandates.
      </p>
    </div>
  </div>
);

export const Clients = () => {
  const allClients = Object.values(CLIENTS).flat();

  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="hairline-b border-b"
    >
      <ClientsMarquee items={allClients} />
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-28">
        <ClientsIntro />
        <div className="space-y-10 md:space-y-14">
          {Object.entries(CLIENTS).map(([cat, names], ci) => (
            <ClientCategory key={cat} category={cat} names={names} index={ci} />
          ))}
        </div>
      </div>
    </section>
  );
};
